import { PropsWithChildren } from 'react';

const ContentContainer = ({
  additionalClassNames = '',
  children,
}: PropsWithChildren & {
  additionalClassNames?: string;
}) => {
  return (
    <div
      className={`mx-auto max-w-290 px-4 min-[1160px]:px-0 ${additionalClassNames}`}
    >
      {children}
    </div>
  );
};

export default ContentContainer;
